import { createLogger, Logger } from '@web-chat-core/toolkit/logger';

const loggers: Map<LOGGERS | string, Logger> = new Map();

export enum LOGGERS {
    Default = 'default',
    AccessRequests = 'access_requests',
    WaitingRoom = 'waiting-room',
}

const logKey = localStorage.getItem('log-enabled');

let globalLevel: 'debug' | 'silent';

if (logKey) {
    globalLevel = 'debug';
} else {
    globalLevel = process.env.NODE_ENV === 'production' ? 'silent' : 'debug';
}

export const registerLogger = (prefix: LOGGERS | string) => {
    const logger = createLogger({ prefix, level: globalLevel });
    loggers.set(prefix, logger);
};

registerLogger(LOGGERS.Default);
registerLogger(LOGGERS.AccessRequests);
registerLogger(LOGGERS.WaitingRoom);

export const getLogger = (key: LOGGERS = LOGGERS.Default): Logger => {
    const logger = loggers.get(key);
    if (!logger) {
        throw new Error(`Logger "${key}" not registered`);
    }
    return logger;
};
